<template>
    <div class="guide_day_wrap" style="padding:10px">
            <div class="time_header">
                <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
                <el-date-picker v-model="dateRange" type="daterange" class="mywidthdaterange" range-separator="-" :clearable="false"  style="width: 230px;"
                                size="medium"  @change="getWxfileInfoList()"
                                start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
                <el-select v-model="moduleCode" placeholder="请选择" filterable  size="medium"  @change="getWxfileInfoList()"  style="width: 140px;">
                    <el-option label="全部模块" :value="0"></el-option>
                    <el-option v-for="item in typeList" :key="item.code" :label="item.name" :value="item.code"></el-option>
                </el-select>
                <el-button type="danger" size="medium" @click="batchDeleteHandler()">删除</el-button>
                 <el-button type="danger" size="medium" @click="delWxfileInfoAll()">删除全部</el-button>
                 {{name}}    {{userSize}}G/{{limitSize}}G
            </div>
                <el-table stripe :data="guideGroupList" border style="width: 100%;" :height="maxH-30"  @selection-change="handleSelectionChange">
                   <el-table-column
                    type="selection"
                    width="40">
                </el-table-column>
                    <el-table-column prop="fileUrl" label="文件路径" align="center"></el-table-column>
                    <el-table-column  label="文件大小" align="center" width="100">
                         <template slot-scope="scope">
                              {{parseFloat(scope.row.fileSize/1024).toFixed(2)}}k
                        </template>
                    </el-table-column>
                    <el-table-column prop="moduleTitle"  width="120" label="所属模块" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column label="文件时间" show-overflow-tooltip align="center" width="180">
                        <template slot-scope="scope">
                            {{scope.row.createTime.split('.')[0]}}
                        </template>
                    </el-table-column> 
                    <el-table-column label="操作" align="center" width="100">
                            <template slot-scope="scope">
                                <el-button  @click.native.prevent="delWxfileInfoByWxfileInfoId(scope.row.id)"  type="text" size="small">删除</el-button>
                           </template>
                    </el-table-column> 
                </el-table>
                <div style="margin-top: 10px;">
                    <el-pagination @size-change="sizeChangeHandler" @current-change="currentChangeHandler"
                                   :current-page.sync="pageNo" :page-sizes="[10, 20, 30, 50]"
                                   :page-size.sync="pageSize" layout="total, sizes, prev, pager, next, jumper"
                                   :total="total">
                    </el-pagination>
                </div>
    </div>
</template>

<script>
    import mixin from '@/mixins/windowResize';
    import {getWxfileInfoList,queryBySchoolId,delWxfileInfoAll,delWxfileInfoByWxfileInfoId,getWxfileInfoSchool} from '@/api/resourceusage';

    export default {
        name: "guideStatisticsClassify",
        data() {
            return {
                dateRange: [this.$moment(new Date()).format('YYYY-MM') + '-01', new Date()],
                typeList: [],
                pageNo: 1,
                pageSize: 20,
                total: null,
                guideGroupList: [],
                schoolId:this.$route.query.schoolId,
                name:this.$route.query.name,
                moduleCode:0,
                multipleSelection:[],
                userSize:"",  
                limitSize:""        
            }
        },
        mixins: [mixin],
        filters: {
            recordTimeFilter(time) {
                return time ? time.substring(11, 16) : '--';
            }
        },
        created() {   
            getWxfileInfoSchool(this.schoolId).then(res => {
                    const data = res.data.data;
                    this.userSize=parseFloat(data.userSize/(1024*1024*1024)).toFixed(2);
                    this.limitSize=parseFloat(data.limitSize/(1024*1024*1024)).toFixed(2)
                })         
              queryBySchoolId(this.schoolId).then(res => {
                    const data = res.data.data;
                    if (res.data.code === 200) {
                        this.typeList = data;
                    }
                })
                this.getWxfileInfoList();
        },
        methods: {
             handleSelectionChange(val) {
                this.multipleSelection = val;
            },
             batchDeleteHandler() {
                if (this.multipleSelection.length === 0) {
                    this.$message.error('请选择要删除的资源');
                } else {
                     this.$confirm('确定要删除吗,删除不可恢复', '提示', {
                    type: 'warning'
                }).then(() => {
                   delWxfileInfoByWxfileInfoId(this.multipleSelection.map(({id}) => id)).then(res => {
                      if (res.data.code === 200) {
                            this.$message({
                                            type: 'success',
                                            message: '删除成功!'
                                        });
                            this.getWxfileInfoList()
                        }                    
                    }).catch(err=>{
                    });
                }).catch(() => { });
                }
            },
             //删除模板
         delWxfileInfoByWxfileInfoId(id){
         this.$confirm('确定要删除吗,删除不可恢复', '提示', {
                    type: 'warning'
                }).then(() => {
                   delWxfileInfoByWxfileInfoId([id]).then(res => {
                      if (res.data.code === 200) {
                            this.$message({
                                            type: 'success',
                                            message: '删除成功!'
                                        });
                            this.getWxfileInfoList()
                        }                    
                    }).catch(err=>{
                    });
                }).catch(() => { });
    },
            delWxfileInfoAll(){
                this.$confirm("确认要全部删除吗，删除后不可恢复", "全部删除", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    lockScroll: false
                }).then(() => {
                    delWxfileInfoAll({
                       startDate: this.$moment(this.dateRange[0]).format('YYYY-MM-DD'),
                    endDate: this.$moment(this.dateRange[1]).format('YYYY-MM-DD'),
                    moduleCode: this.moduleCode,
                    schoolId:this.schoolId,
                    })
                        .then(res => res.data)
                        .then(data => {
                            if(data.result) {
                                this.$message.success('全部删除成功');
                                this.getWxfileInfoList();
                            } else {
                                this.$message.error(data.msg);
                            }
                        })
                });
            },
            getWxfileInfoList() {
                getWxfileInfoList({
                    startDate: this.$moment(this.dateRange[0]).format('YYYY-MM-DD'),
                    endDate: this.$moment(this.dateRange[1]).format('YYYY-MM-DD'),
                    pageNo: this.pageNo,
                    pageSize: this.pageSize,
                    moduleCode: this.moduleCode,
                    schoolId:this.schoolId,
                }).then(res => {
                    const data = res.data.data;
                    if (res.data.code === 200) {
                        this.guideGroupList = data.dataList;
                        this.total = data.pagination.total;
                    }
                })
            },
            sizeChangeHandler() {
                this.pageNo = 1;
                this.getWxfileInfoList();
            },
            currentChangeHandler() {
                this.getWxfileInfoList();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .guide_day_wrap {
            .time_header {
                padding-bottom: 10px;
            }

            .guide_statistics_box {
                overflow-x: hidden;
                overflow-y: auto;

                .chose_teacher {
                    line-height: 25px;
                    color: #409eff;
                }

                .no_chose_teacher {
                    line-height: 50px;
                    color: #F56C6C;
                }
            }
    }
</style>



// WEBPACK FOOTER //
// src/views/resourceusage/resourceusageinfo.vue